/** The HubSpot form behind "Ring meg" — a callback request, not one of the /privat/skjema forms. */
// TODO: source from page.data.ringMegSettings once the Sanity field ships.
export const RING_MEG_FORM_ID = "b27dfce1-bdc5-45ac-a213-16fc003989b4";

/** The form's own page, for links and modal fallbacks. */
export const RING_MEG_PATH = "kundeservice/ring-meg";
